import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Divisions from './pages/Divisions';
import DivisionDetail from './pages/DivisionDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppBubble from './components/WhatsAppBubble';

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-white text-slate-900">
      <BrowserRouter>
        <ScrollToTop />
        <a href="#main-content" className="skip-link">Skip to content</a>
        <Navbar />
        <main id="main-content" tabIndex={-1} className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/divisions" element={<Divisions />} />
            <Route path="/divisions/:slug" element={<DivisionDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppBubble />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
